// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Layout_wrap__GANUa","header":"Layout_header__ci4f5","is_hidden":"Layout_is_hidden__eyqAJ","main":"Layout_main__0_AIL","footer":"Layout_footer__e0cYd"};